import appmaker from '@appmaker/core/index';

// Import MenuItemComponent from language package
import MenuItem from '../lanugage/components/MenuItem';
// Import SubMenuItem from mobile-app package
import SubMenuItem from '../mobile-app/components/SubMenuItem';
import {
	ArchiveTick,
	ColorSwatch,
	Element,
	ElementPlus,
	Eye,
	Grid3,
	LanguageSquare,
	Message,
	MonitorMobbile,
	Notepad,
	Notification1,
	PathTool,
	Setting2,
	TaskSquare,
} from 'iconsax-reactjs';

const plugin = {
	id: '@appmaker/sidebar-groups',
	name: 'Sidebar Groups',
	activate: () => {
		// Register Design Group
		appmaker.registerSideBarGroup(
			{
				name: 'Design',
				icon: PathTool,
				items: [
					{
						name: 'Branding',
						routeName: '/app-design',
						icon: ArchiveTick,
						MenuItemComponent: SubMenuItem,
					},
					{
						name: 'Layout',
						routeName: '/blockEditor',
						icon: Grid3,
						addTracker: {
							eventName: 'customize_app_clicked',
						},
					},
					{
						name: 'App Menu',
						routeName: '/menu/mainmenu',
						icon: TaskSquare,
					},
					{
						name: 'Reusable blocks',
						routeName: '/reusable-blocks',
						icon: Notepad,
					},
					{
						name: 'Template Editor',
						routeName: '/templateEditor',
						icon: Element,
					},
					{
						name: 'Languages',
						routeName: '/language',
						icon: LanguageSquare,
						// MenuItemComponent: MenuItem,
					},
					{
						name: 'Settings',
						routeName: '/settings',
						icon: Setting2,
					},
					{
						name: 'Extensions',
						routeName: '/extension',
						icon: ElementPlus,
					},
					{
						name: 'Themes',
						routeName: '/themes',
						icon: ColorSwatch,
					},
				],
			},
			2
		);

		// Register App Builds (standalone)
		appmaker.registerSideBarMenu(
			{
				name: 'Preview',
				routeName: '/app-builds',
				icon: Eye,
			},
			11
		);

		// Register Upload to Store (standalone)
		appmaker.registerSideBarMenu(
			{
				name: 'Publish',
				routeName: '/upload-to-store',
				icon: MonitorMobbile,
			},
			12
		);

		// Register Engage Group
		appmaker.registerSideBarGroup(
			{
				name: 'Engage',
				icon: Message,
				items: [
					{
						name: 'Push Notification',
						routeName: '/push-notification',
						icon: Notification1,
					},
				],
			},
			13
		);

		// My Account is now handled in sidebar footer
	},
};

export default plugin;
